const getNetworkStatus = (rootState) => rootState.ui.networkErrors.status;

export default getNetworkStatus;
